import React from "react";

function FormAlert(props) {
  return (
    <div
      className={
        "text-center p-4 rounded text-sm" +
        (props.type === "error" ? " text-indigo-600 bg-indigo-50" : "") +
        (props.type === "success" ? " text-green-600 bg-green-50" : "")
      }
    >
      {props.message}
    </div>
  );
}

export default FormAlert;
